var _path, _rect, _path2, _circle, _rect2, _rect3, _rect4, _rect5, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 140,
    viewBox: "0 0 193 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M183.607 103.105C177.901 94.7275 171.272 84.7784 173.165 74.0843C176.374 63.1903 184.192 54.0499 189.952 44.5006C196.755 32.48 191.57 28.4822 180.343 24.0755C176.484 22.6763 171.391 21.904 167.624 20.2867C159.395 15.6802 160.109 7.85721 148.369 2.68733C140.953 -1.42858 133.941 -0.174725 126.251 2.18761C119.869 3.8049 112.893 4.59537 106.319 4.39548C87.4379 3.25974 68.2736 2.23304 49.3562 2.50561C40.5055 2.75093 30.7588 2.84179 22.2281 5.43127C10.4699 10.5557 1.07064 21.0499 0.0374505 34.3699C-0.940878 66.9155 17.6108 73.2484 13.3226 85.2054C9.78417 96.9717 6.55659 120.032 18.3423 127.764C28.3633 132.17 49.6214 122.548 62.0928 122.594C74.2624 121.894 77.9655 124.711 88.1236 129.999C99.5253 135.151 111.969 138.249 124.386 139.412C142.398 141.284 160.904 138.631 177.865 132.27C195.804 125.029 195.091 117.115 183.607 103.096V103.105Z",
    fill: "#080333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.2871,
    y: 96.1263,
    width: 84.5301,
    height: 11.6593,
    rx: 2,
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6859 60.384L95.4656 32.703C96.1268 32.2752 96.9774 32.2752 97.6386 32.703L140.418 60.384C142.092 61.4667 141.325 64.0631 139.332 64.0631H53.7724C51.7794 64.0631 51.0127 61.4667 52.6859 60.384Z",
    fill: "#E8E8FD",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.82966,
    cy: 5.82966,
    r: 5.82966,
    transform: "matrix(-1 0 0 1 102.382 43.6585)",
    fill: "#795AF7",
    stroke: "#000917",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.489,
    y: 96.1263,
    width: 32.0631,
    height: 8.74449,
    transform: "rotate(-90 64.489 96.1263)",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#795AF7;#E8E8FD;#795AF7;#795AF7;#795AF7;#795AF7",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83.4354,
    y: 96.1263,
    width: 32.0631,
    height: 8.74449,
    transform: "rotate(-90 83.4354 96.1263)",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#795AF7;#795AF7;#E8E8FD;#795AF7;#795AF7;#795AF7",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.382,
    y: 96.1263,
    width: 32.0631,
    height: 8.74449,
    transform: "rotate(-90 102.382 96.1263)",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#795AF7;#795AF7;#795AF7;#E8E8FD;#795AF7;#795AF7",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119.871,
    y: 96.1263,
    width: 32.0631,
    height: 8.74449,
    transform: "rotate(-90 119.871 96.1263)",
    fill: "#795AF7",
    stroke: "#080333",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#795AF7;#795AF7;#795AF7;#795AF7;#E8E8FD;#795AF7",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M96.5521 47.064C99.626 47.064 102.137 49.4149 102.365 52.403C102.374 52.2272 102.382 52.0587 102.382 51.8757C102.382 48.1406 99.7727 45.1159 96.5521 45.1159C93.3316 45.1159 90.7225 48.1479 90.7225 51.8757C90.7225 52.0514 90.7225 52.2272 90.7388 52.403C90.9671 49.4149 93.4865 47.064 96.5521 47.064V47.064Z",
    fill: "#080333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M138.817 103.413H54.2871V107.999H138.817V103.413Z",
    fill: "#080333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M73.2335 64.0638H64.489V71.3508H73.2335V64.0638Z",
    fill: "#080333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M92.1799 64.0638H83.4354V71.3508H92.1799V64.0638Z",
    fill: "#080333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M111.126 64.0638H102.382V71.3508H111.126V64.0638Z",
    fill: "#080333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M128.615 64.0638H119.871V71.3508H128.615V64.0638Z",
    fill: "#080333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M138.088 62.6062L142 62.499L96.1674 32.8858L51.5 61.499L54.2871 63.3349L96.1674 37.7019L138.088 62.6062Z",
    fill: "#080333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLoader);
export default __webpack_public_path__ + "static/media/bank-loader.f321b2264d3c5a9245eb00e399b71aa3.svg";
export { ForwardRef as ReactComponent };